import React from 'react';
import '../styles/card.css';

const CardComponent = ({ vehicles = [], loading = false }) => {
  const total = vehicles.length;
  const active = vehicles.filter(v => v.status !== 'offline').length;
  const inactive = vehicles.filter(v => v.status === 'offline').length;
  const running = vehicles.filter(v => v.status === 'running' || v.speed > 3 || v.ignition === true).length;
  const stopped = total - running - inactive;

  const vehicleData = [
    { count: total, label: 'Total Vehicles', color: '#3F77F5' },
    { count: active, label: 'Active', color: '#20C997' },
    { count: inactive, label: 'Inactive', color: '#6C757D' },
    { count: running, label: 'Running', color: '#12B8FF' },
    { count: stopped, label: 'Stopped', color: '#DC3545' },
  ];

  return (
    <div className='dashboard-container'>
      {vehicleData.map((item, index) => (
        <div 
          className='dashboard-item' 
          key={index}
        >
          <div className='circle-wrapper'>
            <div
              className='circle'
              style={{
                backgroundColor: item.color,
                boxShadow: `0 0 0 8px ${item.color}20, 0 0 0 16px ${item.color}10`,
              }}
            >
              {loading ? '-' : item.count}
            </div>
          </div>
          <span className='label'>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default CardComponent;
